"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardStyles = void 0;

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

var cardStyles = {
  padding: (0, _getSpacing.getSpacing)(6),
  borderRadius: (0, _getSpacing.getSpacing)(4),
  backgroundColor: (0, _getColor.getColor)('common', 'white'),
  color: (0, _getColor.getColor)('common', 'whiteContrastText'),
  shadow: ['0px 1px 2px rgba(0, 0, 0, 0.1)', '0px 4px 10px rgba(0, 0, 0, 0.05)']
};
exports.cardStyles = cardStyles;